import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const rGenerator: LanguageGenerator = {
  id: 'r',
  name: 'R',
  category: 'request-examples',
  color: '#276DC3',
  generate(config: ExportConfig): GeneratedFile[] {
    const lines: string[] = [
      '# mail_requests.R — generated by Mail Service SDK Export',
      '# Requires: httr2 (install.packages("httr2"))',
      'library(httr2)',
      '',
      `service_url <- Sys.getenv("${config.serviceUrlVarName}")`,
      '',
    ];

    for (const app of config.apps) {
      lines.push(`# ── ${app.name}`);
      lines.push(`${app.key}_key <- Sys.getenv("${app.envVarName}")`);
      lines.push('');
      for (const t of app.templates) {
        const dataFields = t.schema
          ? t.schema.map((f) => `    ${f.key} = ${f.type === 'number' ? (f.example || '0') : f.type === 'boolean' ? 'TRUE' : `"${f.example || f.key}"`}`).join(',\n')
          : '    # no schema';
        lines.push(`# Send: ${t.name}`);
        lines.push(`request(paste0(service_url, "/v1/send")) |>`);
        lines.push(`  req_method("POST") |>`);
        lines.push(`  req_headers("Content-Type" = "application/json", "X-API-KEY" = ${app.key}_key) |>`);
        lines.push(`  req_body_json(list(`);
        lines.push(`    template_slug = "${t.slug}",`);
        lines.push(`    recipient     = "user@example.com",`);
        lines.push(`    data          = list(`);
        lines.push(dataFields.split('\n').map((l) => '      ' + l).join('\n'));
        lines.push(`    )`);
        lines.push(`  )) |>`);
        lines.push(`  req_perform() |>`);
        lines.push(`  resp_body_json()`);
        lines.push('');
      }
    }

    return [
      { filename: 'mail_requests.R', content: lines.join('\n'), syntax: 'r' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
